"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react/jsx-runtime"),t=require("react"),a=require("styled-components"),s=require("@plans/utilities"),i=require("@vds-tokens/core"),r=require("./ReviewListItem.js");function n(e){return e&&e.__esModule?e:{default:e}}const u=n(a).default.ul.withConfig({displayName:"StyledUL",componentId:"VDS__sc-130rvup-0"})`
  margin: 0;
  padding: ${i.LayoutTokens.space["4X"].value} 0;
  li:last-of-type {
    margin-bottom: 0;
  }
  @media (min-width: ${s.breakpoints.tabletSmall.min}) {
    ${({size:e})=>"small"===e&&`padding: ${i.LayoutTokens.space["6X"].value} 0;`};
  }
`;exports.default=a=>{const{size:s,data:i,spacing:n,surface:l}=a;return i?e.jsx(u,{children:i.map(((e,a)=>t.createElement(r.default,Object.assign({},e,{size:s,key:a,spacing:n,surface:l}))))}):null};
